import { http } from 'http';

export default {
  uploadDocument: ({ container, folder, docType, file }) =>
    http.post(`/3p/docs/${container}/${folder}/${docType}`, file, {
      headers: { 'content-type': 'multipart/form-data' }
    }),
  validateDocument: data => http.post('/edoc/validate', data)
};
